import Vue, { VNode } from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
class ModalComponent extends Vue {

  dtIsValid: boolean;
  /**
   *
   */
  // @ts-ignore
  get lblSetting(): { [ key: string ]: string } {
    return {
      ...require('../../locales/button').default,
      ...require('../../locales/generic-labels').default
    };
  }
  constructor() {
    super();
    this.dtIsValid = false;
  }

  @Prop({ default: false, type: [ Boolean ] })
  value: boolean;
  @Prop({ default: false, type: [ Boolean ] })
  createAnother: boolean;

  @Prop({ default: false, type: [ Boolean ] })
  showCreateAnother: boolean;
  @Prop({ default: null, type: [ String ] })
  createAnotherLabel: string;
  @Prop({ default: false, type: [ Boolean ] })
  hideCloseButton: boolean;
  @Prop({ default: false, type: [ Boolean ] })
  hideDefaultAction: boolean;
  @Prop({ default: false, type: [ Boolean ] })
  loading: boolean;
  @Prop({ default: false, type: [ Boolean ] })
  disabled: boolean;
  @Prop({ default: null, type: [ String, null ] })
  title: string | null;
  @Prop({ default: null, type: [ String, null ] })
  icon: string | null;
  @Prop({ default: 'png', type: [String] })
  iconType: string
  @Prop({ default: '40%', type: [ String ] })
  maxWidth: string;
  @Prop({ default: null, type: [ String, null ] })
  actionPosition: string | null;
  @Prop({ default: null, type: [ String, null ] })
  submitBtnTitle: string | null;
  @Prop({ default: 'white', type: [ String ] })
  color: string;
  @Prop({ default: false, type: [Boolean] })
  isDarkTitle: boolean;
  @Prop({ default: false, type: [Boolean] })
  isRedTitle: boolean;
  @Prop({ default: false, type: [Boolean] })
  isYellowTitle: boolean;
  @Prop({ default: null, type: [ Function ] })
  beforeClose: Function;
  @Prop({ default: false, type: [ Boolean ] })
  onlyCloseAction: boolean;
  get coDialog(): boolean {
    return this.value
  }
  get coCreateAnother(): boolean {
    return this.createAnother;
  }
  set coCreateAnother(value: boolean) {
    this.$emit('update:createAnother', value);
  }
  set coDialog(value: boolean) {

    this.$emit('input', value);
  }

  get coIcon(){
    if( this.icon === 'person_add' ) return ''
    const modalIcon = require.context('../../assets/icon/',false,/\.(png|svg)$/)
    return modalIcon(`./${this.icon}.png`)
  }

  handleRecord() {
    const modal: VNode = this.$slots['default'][0]
    if(modal.data.ref && modal.data.ref === 'profile-modal'){
      const comp= modal.componentInstance as any
      if(!comp.isValidCellphone || !comp.isValidLandline)
        return
    }

    if ((this.$refs[ 'form' ] as any).validate()) {
      this.$emit('onRecord')
    }
  }
  handleRecordForSubmit(event) {
    this.$emit('onRecord')
  }
  @Emit('onClose')
  handleClose(isForced: boolean) {
    if (isForced) this.coDialog = true;

    else if (this.showCreateAnother && this.createAnother)
      return;
    if (this.beforeClose) {
      const allowClose: boolean = this.beforeClose() || false;
      this.coDialog = allowClose;
    }
    else {
      this.coDialog = false;
    }

  }


}

export default ModalComponent;



// WEBPACK FOOTER //
// ./src/components/modal-duplicate/index.ts